export class Color {
    public key: string;
    public value: number;

    constructor(key: string, value: number) {
        this.key = key;
        this.value = value;
    }

    public static colorDictionary: Color[] = [
        new Color("red", 0xd32815),
        new Color("blue", 0x315ad6),
        new Color("green", 0x2cd657),
        new Color("yellow", 0xfbff30),
        new Color("orange", 0xe89025),
        new Color("purple", 0xa325d1),
        new Color("teal", 0x36dbdb),
        new Color("pink", 0xf442d7),
        new Color("black", 0x000000),
        new Color("white", 0xffffff),
        new Color("light grey", 0xb3b7b7),
        new Color("grey", 0x6e6a70),
        new Color("alien_blood", 0x41f495),
    ];

    /**
     * Map that can be used to look up a color by it's name: ColorValue.COLORS.get("red")
     */
    public static COLORS = new Map(Color.colorDictionary.map(x => [x.key, x.value] as [string, number]));


    // Designated planet colors
    public static planetColors: Color[] = [
        new Color("R", 0x00de0e),
        new Color("I", 0x0033cc),
        new Color("A", 0x9500ca),
        new Color("S", 0xff0700),
        new Color("E", 0xffae00),
        new Color("C", 0xedfd00),
    ];

    public static PLANET_COLORS = new Map(Color.planetColors.map(x => [x.key, x.value] as [string, number]));

    public static DIALOG_TEXT_COLOR = 0xF8E71C;
    public static KUDER_PRIMARY = 0x6ec213;
    public static KUDER_SECONDARY = 0x1e91d6;
    public static KUDER_PRIMARY_BUTTON =  0x51821C;
    public static KUDER_SECONDARY_BUTTON = 0x2A7DA7;
}



// WEBPACK FOOTER //
// ./src/games/shared/ColorValue.ts